import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-button-count__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    disabled: _ctx.disabled,
    class: _normalizeClass(["c-button-count", { '-disabled': _ctx.disabled }]),
    onClick: _ctx.emitClickEvent
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (_ctx.kind === 'plus')
          ? (_openBlock(), _createBlock(_component_IconBase, { key: 0 }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("path", { d: "M13.043 10.8477H17.8008V12.8984H13.043V18.2891H10.8633V12.8984H6.10547V10.8477H10.8633V5.86719H13.043V10.8477Z" }, null, -1)
              ])),
              _: 1,
              __: [0]
            }))
          : (_ctx.kind === 'minus')
            ? (_openBlock(), _createBlock(_component_IconBase, { key: 1 }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("path", { d: "M16.8984 12.3711H7.11328V10.6016H16.8984V12.3711Z" }, null, -1)
                ])),
                _: 1,
                __: [1]
              }))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["disabled", "class", "onClick"]))
}